import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { useTranslation } from 'providers/GILT.provider';

import { MiniModalActions } from 'scheduler/components/MiniModalActions.component';

const hideMiniModalWrappers = () => {
  const miniModalWrapEl = document.querySelector('.cal-entry-wrap.cal-state-bg-a.no-modal');

  if (miniModalWrapEl) {
    miniModalWrapEl.style.display = 'none';
  }

  const miniModalWrapElDuplicated = document.querySelector('.cal-entry-wrap.cal-state-bg-a.mini-modal');

  if (miniModalWrapElDuplicated) {
    miniModalWrapElDuplicated.style.display = 'none';
  }
};

const MiniModal = ({ miniModal, pickCurrentStylist, currentTime, createTimeoff, createNewTimeoff, createBooking, columnStylistId }) => {
  const { t } = useTranslation();
  const [hideMiniModal, setHideMiniModal] = useState(miniModal);
  const [miniModalClicked, setMiniModalClicked] = useState(false);

  useEffect(() => {
    if (!miniModal) {
      setHideMiniModal(false);
    }
  }, [miniModal]);

  const closeMiniModalFunc = useCallback((hideWrapper) => {
    setHideMiniModal(false);

    const miniModalWrapEl = document.querySelector('.cal-entry-wrap.cal-state-bg-a');

    if (miniModalWrapEl && hideWrapper) {
      miniModalWrapEl.style.display = 'none';
    }
  }, []);

  const handleClickOutside = useCallback(() => {
    if (miniModalClicked) {
      return;
    }

    setHideMiniModal(false);
    pickCurrentStylist(0, moment());
    hideMiniModalWrappers();
  }, [miniModalClicked, pickCurrentStylist]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [handleClickOutside]);

  const createTimeoffHandler = useCallback(() => {
    setMiniModalClicked(true);
    createTimeoff(currentTime);
    closeMiniModalFunc();
  }, [closeMiniModalFunc, createTimeoff, currentTime]);

  const createNewTimeoffHandler = useCallback(() => {
    setMiniModalClicked(true);
    createNewTimeoff(currentTime);
    closeMiniModalFunc();
  }, [closeMiniModalFunc, createNewTimeoff, currentTime]);

  const createBookingHandler = useCallback(() => {
    setMiniModalClicked(true);
    createBooking(currentTime);
    closeMiniModalFunc();
  }, [closeMiniModalFunc, createBooking, currentTime]);

  if (!hideMiniModal) {
    return null;
  }

  return (
    <MiniModalActions
      columnStylistId={columnStylistId}
      onClose={() => closeMiniModalFunc(true)}
      onCreateTimeoff={createTimeoffHandler}
      onCreateNewTimeoff={createNewTimeoffHandler}
      onCreateBooking={createBookingHandler}
      t={t}
    />
  );
};

export default MiniModal;
